import React from 'react';
import { ClienteConsolidado } from '../types';
import { formatCurrency, formatKwh } from '../utils';

interface Props {
  clientes: ClienteConsolidado[];
}

const AnaliseSaldos: React.FC<Props> = ({ clientes }) => {
  const cComSaldo = clientes.filter(c => c.saldoAcumulado > 0).sort((a, b) => b.saldoAcumulado - a.saldoAcumulado).slice(0, 50);

  return (
    <div className="p-6 h-full flex flex-col">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-800">Análise de Saldos Acumulados</h2>
        <p className="text-sm text-gray-500">Energia retida passível de recuperação judicial ou distrato</p>
      </div>

      <div className="flex-1 bg-white border border-gray-200 rounded-xl overflow-hidden flex flex-col">
        <div className="overflow-x-auto flex-1">
          <table className="w-full text-sm text-left">
            <thead className="text-xs text-gray-500 uppercase bg-blue-50 border-b border-blue-100 sticky top-0 z-10">
              <tr>
                <th className="px-4 py-3 font-bold text-blue-900">Cliente</th>
                <th className="px-4 py-3 font-bold text-blue-900 text-right">Saldo Bloqueado (kWh)</th>
                <th className="px-4 py-3 font-bold text-blue-900 text-right">Dívida Atual</th>
                <th className="px-4 py-3 font-bold text-blue-900">Status Distrato</th>
              </tr>
            </thead>
            <tbody>
              {cComSaldo.length === 0 ? (
                <tr><td colSpan={4} className="px-4 py-8 text-center text-gray-500">Nenhum cliente com saldo retido.</td></tr>
              ) : (
                cComSaldo.map(c => (
                  <tr key={c.nome} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="px-4 py-3 font-semibold text-gray-800">{c.nome}</td>
                    <td className="px-4 py-3 text-right font-black text-blue-600">{formatKwh(c.saldoAcumulado)}</td>
                    <td className="px-4 py-3 text-right font-bold text-red-600">{formatCurrency(c.valorTotal)}</td>
                    <td className="px-4 py-3">
                      <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-gray-100 text-gray-600">Ação Manual</span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AnaliseSaldos;
